import type { Quote, QuoteAging, QuoteDetail } from './types';

export interface QuotesQuery {
  from: string;
  to: string;
  sid?: number | null;
  slid?: string;
  ctrmn_id?: string;
  aging?: QuoteAging | 'all';
  limit?: number;
}

function buildQS(params: { [k: string]: unknown }): string {
  const parts: string[] = [];
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  }
  return parts.length ? '?' + parts.join('&') : '';
}

async function fetchJSON<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: 'same-origin' });
  if (res.status === 401) throw new Error('unauthenticated');
  if (res.status === 403) throw new Error('forbidden');
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
  return (await res.json()) as T;
}

export function fetchQuotes(q: QuotesQuery): Promise<Quote[]> {
  return fetchJSON<Quote[]>('/api/quotes' + buildQS({ ...q }));
}

export function fetchQuoteDetail(sid: number, tnum: number): Promise<QuoteDetail> {
  return fetchJSON<QuoteDetail>(`/api/quotes/${sid}/${tnum}`);
}
